"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var updateCategory_1 = require("../orchestrators/updateCategory");
/* tslint:disable:forbid-import */
var satcheljs_1 = require("satcheljs");
/* tslint:enable:forbid-import */
exports.default = satcheljs_1.orchestratorAction('selectCategory', function selectCategory(category) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var currentSubCategoryKey;
        return tslib_1.__generator(this, function (_a) {
            currentSubCategoryKey = category.subcategories && category.subcategories[0] && category.subcategories[0].key;
            updateCategory_1.default(category.key, currentSubCategoryKey, null);
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=selectCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/orchestrators/selectCategory.js
// module id = 5276
// module chunks = 2